"use client";

import React from "react";
import ScrollToTopButton from "./ScrollToTopButton";
import ButtonAsk from "./WhatAppsButton";

const FloatingButtons = () => {
  return (
    <div className="fixed bottom-5 right-5 flex flex-col items-end gap-4 z-50">
      <ScrollToTopButton />
      <ButtonAsk />
    </div>
  );
};

export default FloatingButtons;